<div class="superadmin-popup">
  <h4 class="dialog-title text-center">{{ 'Edit Sensor' | translate }}</h4>

  <hr />

  <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>

  <div class="mb-4">
    <div mat-dialog-content>
      <div class="row">
        <div class="col-md-12">
          <mat-form-field>
            <mat-label>{{ 'Device ID' | translate }}</mat-label>
            <input matInput [(ngModel)]="sensor.id" readonly class="cursor-not-allowed"
              [title]="'Device ID cannot be changed' | translate" />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-broadcast-tower"></i>
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Device Name' | translate }}</mat-label>
              <input matInput [(ngModel)]="sensor.name" required />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-tag"></i>
              </mat-icon>
              <mat-error>{{ 'Device Name is required' | translate }}</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Device Version' | translate }}</mat-label>
              <mat-select [(ngModel)]="sensor.deviceVersionId" required>
                @for (deviceVersion of deviceVersions; track trackById($index, deviceVersion)) {
                  <mat-option [value]="deviceVersion.id">
                    {{deviceVersion.version}}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-laptop-code"></i>
              </mat-icon>
              <mat-error>{{ 'Device Version is required' | translate }}</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-12 padding-y-10">
            <mat-icon class="mr-3">
              <i class="fas fa-check-circle"></i>
            </mat-icon>
            <mat-label class="mr-3">{{ 'Status' | translate }}</mat-label>
            <mat-slide-toggle color="primary" [(ngModel)]="sensor.status"></mat-slide-toggle>
            <hr class="field-underline" />
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Tenant' | translate }}</mat-label>
              <mat-select [(ngModel)]="sensor.tenantId" (ngModelChange)="onTenantChange($event)" required>
                @for (tenant of tenants; track trackById($index, tenant)) {
                  <mat-option [value]="tenant.id">
                    {{tenant.name}}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-building"></i>
              </mat-icon>
              <mat-error>{{ 'Tenant is required' | translate }}</mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-12 padding-y-10">
            <mat-label class="d-block mb-2">{{ 'Organization Level' | translate }} *</mat-label>
            <app-org-tree-select
              [nodes]="orgLevelOptions"
              [selectedId]="sensor.organizationLevelId ?? null"
              [placeholder]="'Select organization level'"
              [hideNullOption]="true"
              [disabled]="!sensor.tenantId"
              (selectionChange)="onOrganizationLevelChange($event)">
            </app-org-tree-select>
            <hr class="field-underline" />
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'IMEI No' | translate }}</mat-label>
              <input matInput [(ngModel)]="sensor.imeI_No" />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-barcode"></i>
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Latitude' | translate }}</mat-label>
              <input type="number" matInput [(ngModel)]="sensor.latitude" min="-90" max="90" />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-map-marker-alt"></i>
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Longitude' | translate }}</mat-label>
              <input type="number" matInput [(ngModel)]="sensor.longitude" min="-180" max="180" />
              <mat-icon matPrefix class="mr-3">
                <i class="fas fa-map-marker-alt"></i>
              </mat-icon>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <mat-form-field>
              <mat-label>{{ 'Installation Date' | translate }}</mat-label>
              <input matInput [(ngModel)]="sensor.installationDate" [owlDateTime]="installDate"
                [owlDateTimeTrigger]="installDate" class="clickable" required />
                <mat-icon matPrefix class="clickable mr-3" [owlDateTimeTrigger]="installDate">
                  <i class="fas fa-calendar-alt"></i>
                </mat-icon>
                <mat-error>{{ 'Installation Date is required' | translate }}</mat-error>
                <owl-date-time #installDate></owl-date-time>
              </mat-form-field>
            </div>

            <div class="col-md-12 padding-y-10">
              <mat-icon class="mr-3">
                <i class="fas fa-location-arrow"></i>
              </mat-icon>
              <mat-label class="mr-3">{{ 'GPS Capability' | translate }}</mat-label>
              <mat-slide-toggle color="primary" [(ngModel)]="sensor.gpsCapability"></mat-slide-toggle>
              <hr class="field-underline" />
            </div>

            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{ 'Table Names' | translate }}</mat-label>
                <mat-select [(ngModel)]="sensor.tableNames" multiple required>
                  @for (tableName of tableNames; track trackByIndex($index)) {
                    <mat-option [value]="tableName">
                      {{tableName}}
                    </mat-option>
                  }
                </mat-select>
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-table"></i>
                </mat-icon>
                <mat-error>{{ 'Table Names are required' | translate }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12 padding-y-10">
              <mat-icon class="mr-3">
                <i class="fas fa-video"></i>
              </mat-icon>
              <mat-label class="mr-3">{{ 'Video Capability' | translate }}</mat-label>
              <mat-slide-toggle color="primary" [(ngModel)]="sensor.videoCapability"></mat-slide-toggle>
              <hr class="field-underline" />
            </div>

            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{ 'Density' | translate }}</mat-label>
                <input type="number" matInput [(ngModel)]="sensor.density" required />
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-braille"></i>
                </mat-icon>
                <mat-error>{{ 'Density is required' | translate }}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-md-12">
              <mat-form-field>
                <mat-label>{{ 'AirNow IntlAQSCode' | translate }}</mat-label>
                <input matInput [(ngModel)]="sensor.airNowIntlAQSCode" />
                <mat-icon matPrefix class="mr-3">
                  <i class="fas fa-wind"></i>
                </mat-icon>
              </mat-form-field>
            </div>

            <div class="col-md-12 padding-y-10">
              <mat-icon class="mr-3">
                <i class="fas fa-cog"></i>
              </mat-icon>
              <mat-label class="mr-3">{{ 'Configuration Capability' | translate }}</mat-label>
              <mat-slide-toggle color="primary" [(ngModel)]="sensor.configurationCapability"></mat-slide-toggle>
              <hr class="field-underline" />
            </div>
          </div>
        </div>

        <div mat-dialog-actions align="end">
          <button mat-button class="btn button-primary" (click)="save()" [class.button-spinner]="isLoading"
            [disabled]="!sensor.name || !sensor.deviceVersionId || !sensor.tenantId || !sensor.organizationLevelId || !sensor.installationDate || !sensor.tableNames || isLoading">
            {{ 'Save' | translate }}
          </button>

          <button mat-button class="btn button-accent" mat-dialog-close>{{ 'Cancel' | translate }}</button>
        </div>
      </div>
    </div>
